// import layout from './layout'
import layout from './layout_v2';
export default layout;